import type { HelpFile } from '../../types/help'
import { UnifiedSearchBarDemoTestIds } from '../../../testids/UnifiedSearchBarDemoTestIds'

export const unifiedSearchBarDemoHelp: HelpFile = {
  docPage: '/docs/components/unified-search-bar',
  texts: {
    [UnifiedSearchBarDemoTestIds.demoPageTitle]: 'Showcase of the unified search bar across all supported filter modes.',
    [UnifiedSearchBarDemoTestIds.demoCardTitle]: null,
    [UnifiedSearchBarDemoTestIds.demoBoolean]: null,
    [UnifiedSearchBarDemoTestIds.demoDaterange]: null,
    [UnifiedSearchBarDemoTestIds.demoDynamicAttr]: null,
    [UnifiedSearchBarDemoTestIds.demoEmpty]: null,
    [UnifiedSearchBarDemoTestIds.demoManyChips]: null,
    [UnifiedSearchBarDemoTestIds.demoMultiEnum]: null,
    [UnifiedSearchBarDemoTestIds.demoNullSentinel]: null,
    [UnifiedSearchBarDemoTestIds.demoStatusMulti]: null,
    [UnifiedSearchBarDemoTestIds.demoTextOnly]: null,
    [UnifiedSearchBarDemoTestIds.demoUuidPending]: null,
  },
}
